module.exports = __webpack_public_path__ + "static/media/xxx.a0b6a7dc.jpg";